<template>
    <div class="container">
        <div v-if="loaded">
            <h1 class="page-header">Academic Catalog <select v-model="year_id">
                <option v-for="y in years" :value="y.id">{{y.title}}</option>
            </select></h1>
            <div class="row">
                <div class="col-sm-3">
                    <ul class="nav nav-pills nav-stacked">
                        <li v-for="p in year.pages" :class="(p.id == page_id)?'active':''"><a href="#catalog-page" @click.stop.prevent="selectPage(p)">{{p.title}}</a></li>
                    </ul>
                </div>
                <div class="col-sm-9">
                    <catalog-page id="catalog-page" :page_id="page_id"></catalog-page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CatalogPage from '../partials/CatalogPage.vue';
    export default {
        name: 'catalog',
        components: {'catalog-page': CatalogPage},
        data() {
            return {
                loaded: false,
                year: {},
                year_id: 'current',
                page_id: null,
                years: [],
            };
        },
        watch: {
            year_id(newval, oldval)
            {
                if(newval != oldval && oldval > 0)
                {
                    console.log(oldval, newval);
                    this.refresh();
                }

            }
        },
        methods: {
            selectPage(p)
            {
                this.$router.push({name: 'catalog', params: {year: this.year.id, slug: p.slug}});
                this.page_id = p.id;
            },
            refresh() {
                this.$http.get('/api/catalog/' + this.year_id + '/' + this.$route.params.slug).then(response => {
                    this.year = response.data.year;
                    this.year_id = this.year.id;
                    this.years = response.data.years;
                    this.loaded = true;

                    for(var i in this.year.pages)
                    {
                        var page = this.year.pages[i];
                        if(page.slug == this.$route.params.slug)
                        {
                            this.page_id = page.id;
                        }
                    }

                    if(this.page_id === null)
                    {
                        this.page_id = this.year.pages[0].id;
                    }
                });
            },
        },
        mounted() {
            this.year_id = this.$route.params.year;
            this.refresh();
        }
    }
</script>

